import { useEffect } from "react";

type Theme = "light" | "dark";

/**
 * Theme hook — 暫時鎖定 light mode。
 *
 * 客戶決定 CMS 一律使用 light mode（dark mode 切換已從 UI 隱藏，hook 仍保留
 * 簽名以避免大規模 refactor）。`toggleTheme` 是 noop，`theme` 永遠回 'light'。
 *
 * 重新啟用 dark mode：恢復原本根據 localStorage / prefers-color-scheme 判斷的邏輯，
 * 並把 MainLayout / admin-header / admin-sidebar 三處的 toggle button 解除隱藏。
 */
export function useTheme(): { theme: Theme; toggleTheme: () => void } {
  useEffect(() => {
    // 強制移除 .dark class，無論之前狀態為何
    document.documentElement.classList.remove("dark");
    // 清除舊的偏好（避免重新啟用 dark mode 時讀到 stale 'dark' 值）
    try {
      localStorage.removeItem("cms-theme");
    } catch {
      // localStorage 不可用時忽略
    }
  }, []);

  return { theme: "light", toggleTheme: () => {} };
}
